import { useState } from 'react';

import { GridFilter, ContainerFilter, FilterButton, CleanButton, Div, TextFildStyled } from './style';
import { Grid, MenuItem } from '@mui/material';

const allMonths = [
    'Janeiro',
    'Fevereiro',
    'Março',
    'Abril',
    'Maio',
    'Junho',
    'Julho',
    'Agosto',
    'Setembro',
    'Outubro',
    'Novembro',
    'Dezembro'
];

const ConsultantDateFilter = ({ years, filterYear, setFilterYear, filterMonth, setFilterMonth, handleFilterClick, handleClean }) => {
    const yearValue = filterYear ?? new Date().getFullYear();
    const monthValue = filterMonth ?? new Date().getMonth() + 1;

    const listYear = [];
    const currentYear = new Date().getFullYear();

    for (let year = 2023; year <= currentYear; year++) {
        listYear.push(year);
    }

    return (
        <GridFilter item xs={12} marginBottom="2rem">
            <ContainerFilter>
                <Grid item xs={2}>
                    <p>Ano</p>
                    <Div width="100%">
                        <TextFildStyled fullWidth size={'small'} select value={yearValue} onChange={(e) => setFilterYear(e.target.value)}>
                            {listYear.length > 0 &&
                                listYear?.map((value, key) => (
                                    <MenuItem key={key} value={value}>
                                        {value}
                                    </MenuItem>
                                ))}
                        </TextFildStyled>
                    </Div>
                </Grid>
                <Grid item marginLeft={4} xs={2}>
                    <p>Mês</p>
                    <Div width="100%">
                        <TextFildStyled fullWidth size={'small'} select value={monthValue} onChange={(e) => setFilterMonth(e.target.value)}>
                            <MenuItem value="Todos">Todos</MenuItem>
                            {allMonths?.map((value, key) => (
                                <MenuItem key={key} value={key + 1}>
                                    {value}
                                </MenuItem>
                            ))}
                        </TextFildStyled>
                    </Div>
                </Grid>
            </ContainerFilter>
            <Grid item padding={2}>
                <CleanButton onClick={handleClean}>Limpar</CleanButton>
            </Grid>
            <Grid item padding={2}>
                <FilterButton variant="contained" color="primary" onClick={handleFilterClick}>
                    Filtrar
                </FilterButton>
            </Grid>
        </GridFilter>
    );
};

export default ConsultantDateFilter;
